import React from 'react';
// Components
import MyInterviewsTable from './MyInterviewsTable/MyInterviewsTable';

const MyInterviews: React.FC = () => {
  return <MyInterviewsTable />;
};

export default MyInterviews;
